




































































































import { Component, Prop, Model, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
const cssPrefix = 'sw-textarea';
/**
 * @event input `(value: string)`
 * @event focus `(event: MouseEvent)`
 * @event blur `(event: MouseEvent)`
 * @event keyup `(event: MouseEvent)`
 * @event enter `(event: MouseEvent)`
 */
@Component
export default class SwTextarea extends SwExtendedVue{
  @Model('input', { type: String, required: true })
  value: string;

  @Prop({ type: Number, default: 4, required: true })
  rows: number;

  @Prop({ type: Number, default: 50, required: true })
  cols: number;

  @Prop({ type: String, required: true })
  name: string;

  @Prop({ type: String, default: 'normal' })
  type: 'normal' | 'password' | 'readonly' | 'display';

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: String, default: '' })
  placeholder: string;

  cssPrefix: string = cssPrefix;
  isFocus: boolean = false;

  valueBeforeChange: string = this.value;

  get isInputReadonly(): boolean {
    return this.type === 'readonly' || this.type === 'display';
  }
  onInput(event: Event) {
    const inputEl = (event.currentTarget as HTMLInputElement);
    const changedValue: string = inputEl.value.trim();
    this.$emit('input', changedValue);
  }
  onFocus(event: MouseEvent) { this.isFocus = !this.disabled; this.$emit('focus', event); }
  onBlur(event: MouseEvent) {
    this.isFocus = false;
    this.$emit('blur', event);
  }
  onKeyup(event: MouseEvent) {
    if (event.which === 13) {
      this.$emit('enter', event);
    }
  }
  public focus() {
    const inputEl = this.$refs.textarea as HTMLElement;
    if (inputEl) { inputEl.focus(); }
  }
  @Watch('value')
  onValueChanged() {
    this.valueBeforeChange = this.value;
  }
}
